import { DataStatus, Message } from 'src/core/engine';
import { AppendState as CartState } from 'src/core/state/cart';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useCallback } from 'react';

import { AppendState, CouponMsg } from '../coupon.register';

export interface CouponApi {
    status: DataStatus;
    pending: boolean;
    messages: Message[];
    current: string | undefined;
    applyCoupon(coupon: string);
    removeCoupon();
    clearMessages();
}

function selector(state: AppendState<CartState>) {
    const cartPending = state.cart.status === DataStatus.Pending;
    const pending = state.coupon.status === DataStatus.Pending;
    // coupon_code is on the raw cart data, not on the normalized totals
    const current = (state.cart.raw as any)?.applied_coupons?.[0]?.code;
    return {
        status: state.coupon.status,
        messages: state.coupon.messages,
        pending: cartPending || pending,
        current,
    };
}

export function useCoupon(): CouponApi {
    const dispatch = useDispatch();
    const { status, messages, pending, current } = useSelector(selector, shallowEqual);
    const applyCoupon = useCallback(
        (coupon: string) => {
            dispatch(CouponMsg('Coupon.Apply', coupon));
        },
        [dispatch],
    );
    const removeCoupon = useCallback(() => {
        dispatch(CouponMsg('Coupon.Delete'));
    }, [dispatch]);

    const clearMessages = useCallback(() => {
        dispatch(CouponMsg('Coupon.Reset'));
    }, [dispatch]);

    return {
        current,
        messages,
        status,
        pending,
        applyCoupon,
        removeCoupon,
        clearMessages,
    };
}
